import { groupBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";

export type filtarAtividadesSaida = {
    cod_talhao: number,
    nome_talhao: string,
    nome_propriedade: string,
    atvs_planejadas: number,
    atvs_executadas: number,
    atvs_concluidas: number,
    lista_atividades: Item__Atividades[]
}
export function filtarAtividades(cod_filtrar_atividade: number, data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[]):filtarAtividadesSaida[] {

    function obterNomeTalhao(cod_talhao: number) {
        //@ts-ignore
        let lista_talhoes = (data_propriedades??[]).map(item=>item.talhao).flat();
        let find_talhao = (lista_talhoes??[])?.find(item=>item.cod === cod_talhao)?.nome ?? null
        return find_talhao ?? '???'
    };

    let atividades_da_propriedade__01 = (data_atividades ?? []).filter(i => i.cod_propriedade === cod_filtrar_atividade);

    let agrupar_por_talhao__02 = groupBy(atividades_da_propriedade__01, 'cod_talhao');

    function obterQtdExecutada(cod_talhao: number) {
         //@ts-ignore
        let executadas = (atividades_da_propriedade__01??[]).filter(i=>i.cod_tipo===2 && i.cod_talhao==cod_talhao).map(i=> i.andamentos).flat();
        return executadas?.length ?? 0;
    }

    let estrutura__03 = (Object.entries(agrupar_por_talhao__02) ?? []).map(([cod_talhao, lista_atividades]) => {
        return {
            cod_talhao: Number(cod_talhao),
            nome_talhao: obterNomeTalhao(Number(cod_talhao)),
            nome_propriedade: lista_atividades?.[0]?.propriedade_nome,
            atvs_planejadas: ((lista_atividades??[])?.filter(i=> i.cod_tipo === 1))?.length ?? 0,
            atvs_executadas: obterQtdExecutada(Number(cod_talhao)) ?? 0,
            atvs_concluidas: (lista_atividades??[]).filter(i=> i.concluido)?.length ?? 0,
            lista_atividades: lista_atividades
        }
    })

    return estrutura__03 ?? [];
};

export function filtarAtividadesPorTralhao(cod_filtrar_atividade: number, data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[]):filtarAtividadesSaida[] {

    function obterNomeTalhao(cod_talhao: number) {
        //@ts-ignore
        let lista_talhoes = (data_propriedades??[]).map(item=>item.talhao).flat();
        let find_talhao = (lista_talhoes??[])?.find(item=>item.cod === cod_talhao)?.nome ?? null
        return find_talhao ?? '???'
    };

    let atividades_da_propriedade__01 = (data_atividades ?? []).filter(i => i.cod_talhao === cod_filtrar_atividade);

    let agrupar_por_talhao__02 = groupBy(atividades_da_propriedade__01, 'cod_talhao');

    function obterQtdExecutada(cod_talhao: number) {
         //@ts-ignore
        let executadas = (atividades_da_propriedade__01??[]).filter(i=>i.cod_tipo===2 && i.cod_talhao==cod_talhao).map(i=> i.andamentos).flat();
        return executadas?.length ?? 0;
    }

    let estrutura__03 = (Object.entries(agrupar_por_talhao__02) ?? []).map(([cod_talhao, lista_atividades]) => {
        return {
            cod_talhao: Number(cod_talhao),
            nome_talhao: obterNomeTalhao(Number(cod_talhao)),
            nome_propriedade: lista_atividades?.[0]?.propriedade_nome,
            atvs_planejadas: ((lista_atividades??[])?.filter(i=> i.cod_tipo === 1))?.length ?? 0,
            atvs_executadas: obterQtdExecutada(Number(cod_talhao)) ?? 0,
            atvs_concluidas: (lista_atividades??[]).filter(i=> i.concluido)?.length ?? 0,
            lista_atividades: lista_atividades
        }
    })

    return estrutura__03 ?? [];
};


export function obterDetalhesAtvspropriedades(cod_filtrar_atividade: number, data_atividades: Item__Atividades[]) {

    let atvs_da_propriedade = (data_atividades ?? []).filter(i => i.cod_propriedade === cod_filtrar_atividade);
    //@ts-ignore
    let executadas = (atvs_da_propriedade??[]).filter(i=>i.cod_tipo===2).map(i=> i.andamentos).flat();
    return {
        area_total: atvs_da_propriedade?.reduce((acc, i)=> acc + Number(i.area), 0) ?? 0,
        area_executada: atvs_da_propriedade?.reduce((acc, i)=> acc + Number(i.area_executada), 0) ?? 0,
        qtd_planejadas: (atvs_da_propriedade??[]).filter(i=>i.cod_tipo===1).length ?? 0,
        qtd_executadas: executadas?.length,
        qtd_concluidas: atvs_da_propriedade?.filter(i=> i.concluido).length ?? 0
    }
}

export function obterDetalhesAtvsTalhoes(cod_filtrar_atividade: number, data_atividades: Item__Atividades[]) {

    let atvs_do_talhao = (data_atividades ?? []).filter(i => i.cod_talhao === cod_filtrar_atividade);
    //@ts-ignore
    let executadas = (atvs_do_talhao??[]).filter(i=>i.cod_tipo===2).map(i=> i.andamentos).flat();
    return {
        area_total: atvs_do_talhao?.reduce((acc, i)=> acc + Number(i.area), 0) ?? 0,
        area_executada: atvs_do_talhao?.reduce((acc, i)=> acc + Number(i.area_executada), 0) ?? 0,
        qtd_planejadas: (atvs_do_talhao??[]).filter(i=>i.cod_tipo===1).length ?? 0,
        qtd_executadas: executadas?.length,
        qtd_concluidas: atvs_do_talhao?.filter(i=> i.concluido).length ?? 0
    }
}